export default "__VITE_ASSET__CV44ujq5__"